



























import Vue, { PropType } from 'vue'
import MdIcon from './MdIcon.vue'
import FaIcon from './FaIcon.vue'
import CustomIcon from './CustomIcon.vue'

export type IconType = 'custom' | 'font-awesome' | 'material'
export type Size = 'small' | 'medium' | 'large' | 'xlarge'
const iconSizes: { [key in Size]: number } = {
  small: 18,
  medium: 24,
  large: 36,
  xlarge: 48,
}

export type IconProps = {
  size?: number | string
  type?: IconType
  name: string
}

export default Vue.extend<{}, {}, {}, IconProps>({
  name: 'XIcon',
  components: { MdIcon, FaIcon, CustomIcon },
  props: {
    size: {
      type: [Number, String] as PropType<number | Size>,
      default: 'medium',
    },
    type: {
      type: String as PropType<IconType>,
      default: 'material',
    },
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    computedSize(): string {
      const unit = 'px'
      const size: number | Size = this.$props.size
      const diameter = typeof size === 'number' ? size : iconSizes[size]
      return `${diameter}${unit}`
    },
  },
})
